import React, { useState, useEffect } from 'react';
import { Category } from '../../pages/Accounts/Accounts.interface';
import './categories.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import '../../utils/fa_brand_icons_library';
import { Collapse } from 'react-collapse';
import { isEmpty } from 'lodash';
import { loadCategories } from '../../utils/categories_loader';
import FaIconView from '../FaIconView/FaIconView';

interface Props {
  categories?: Category[];
  selected?: Category;
  onCategorySelect: (category: Category) => void;
}

const CategoriesList: React.FC<Props> = (props) => {
  const { selected, onCategorySelect } = props;

  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState<Category>();
  const [openCollapse, setOpenCollapse] = useState(false);

  useEffect(() => {
    const loadLocalCats = () => {
      const cats = JSON.parse(localStorage.getItem('categories') || '[]');
      if (!isEmpty(cats)) {
        setCategories(cats);
      }
    }

    loadLocalCats();
  }, []);

  useEffect(() => {
    const updateLocalCategories = () => {
      loadCategories().then((cats) => {
        if (isEmpty(categories)) setCategories(cats);
        localStorage.setItem('categories', JSON.stringify(cats));
      });
    }

    updateLocalCategories();
  }, []);

  useEffect(() => {
    if (categories.length > 0) {
      if(!selected) {
        setSelectedCategory(categories[0]);
        onCategorySelect(categories[0]);
      }
      setLoading(false);
    }
  }, [categories, selected]);

  useEffect(() => {
    setSelectedCategory(selected);
  }, [selected]);

  const onCategorySelected = (category: Category) => {
    setSelectedCategory(category);
    onCategorySelect(category);
    setOpenCollapse(false);
  };

  const Menu = () => {
    return categories.map((category) => {
      const iconName = category.id.toLowerCase() as IconName;
      return (
        <div
          className="category-container"
          key={category.id}
          onClick={() => onCategorySelected(category)}
          role="button"
          style={{
            backgroundColor: category.bgColor,
            color: category.frontColor,
          }}
        >
          <FontAwesomeIcon size="2x" icon={['fab', iconName]} />
          <div>{category.name}</div>
        </div>
      );
    });
  };

  if (loading || !selectedCategory) return <div>الرجاء الانتظار...</div>;

  return (
    <div>
      <div
        className="list-toggle-container"
        onClick={() => setOpenCollapse(!openCollapse)}
        role="button"
        style={{
          backgroundColor: selectedCategory!.bgColor,
          color: selectedCategory!.frontColor,
        }}
      >
        <FaIconView
          containerStyle="list-toggle"
          iconStyle="list-toggle-icon"
          label={selectedCategory!.name}
          icon={['fab', selectedCategory!.id.toLowerCase()]}
          iconSize="1x"
        />
        <FontAwesomeIcon icon={openCollapse ? 'angle-up' : 'angle-down'} />
      </div>

      <Collapse isOpened={openCollapse}>
        <div className="categories-container">{Menu()}</div>
      </Collapse>
    </div>
  );
};

export default CategoriesList;
